import drawBottomTextRing from "./drawBottomTextRing";
import drawTopTextRing from "./drawTopTextRing";

const drawTextRings = (
    x, y, orr, orir,
    onePartSize, rotation, textIds
) => {
    return [
        drawBottomTextRing(
            x, y, orir + ((orr - orir) / 2) + 5, onePartSize, rotation, textIds.bottomTextId
        ),
        drawTopTextRing(
            x, y, orir + ((orr - orir) / 2) - 8, onePartSize, rotation, textIds.topTextId
        ),
        drawBottomTextRing(
            x, y, orir - 30, onePartSize, rotation, textIds.innerBottomTextId
        ),
        drawBottomTextRing(
            x, y, orir - 15, onePartSize, rotation, textIds.innerBottomTextLine2Id
        ),
        drawTopTextRing(
            x, y, orir - 30, onePartSize, rotation, textIds.innerTopTextId
        ),
        drawTopTextRing(
            x, y, orir - 45, onePartSize, rotation, textIds.innerTopTextLine2Id
        )
    ];
};

export default drawTextRings;
